export default "__VITE_ASSET__3345e51f__"